import React from 'react';

import { GUEST_PATH } from '../../../../constants';

const TrainingCertification = React.lazy(() => import('../../Subscriber/MyDesignation'));

const Routes = {
     path: GUEST_PATH.DESIGNATION,
     breadcrumb: 'Training Certification',
     element: <TrainingCertification />,
};

export default Routes;
